import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Logo from '../../Images/logoCertificate.png';
import Podpis from '../../Images/podpis.jpg';
import BackCert from '../../Images/backCert.png';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Download } from 'lucide-react';
import { Button, EmptyState } from '../../Components/ui';
import './CertificateView.css';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import { data } from '../../constants';

const CertificateFile = () => {
    const certRef = useRef(null);
    const { id, courseId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    // Faqat ko'rinish uchun: "Orqaga" tugmasi tizimga kirgan foydalanuvchiga (QR orqali kelganlarga emas).
    const isLoggedIn = Boolean(localStorage.getItem('admin_token'));

    const certificate = location.state?.certificate;

    console.log(certificate);

    // const person = data.find(item => item.id === id);
    const currentCertificate = certificate?.certificates?.find(
        item => String(item.certificateId) === String(courseId)
    );
    const url = `https://management.iifa.uz/certificate/${id}/${courseId}`;

    // const handleDownload = async () => {
    //     const element = certRef.current;
    //     const canvas = await html2canvas(element, {
    //         scale: 2,
    //         useCORS: true
    //     });
    //     const imgData = canvas.toDataURL("image/png");
    //     const pdf = new jsPDF({
    //         orientation: "landscape",
    //         unit: "px",
    //         format: [canvas.width, canvas.height],
    //     });
    //     pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
    //     const courseName = person.certificates.find(item => item.id === courseId)?.name || "certificate";
    //     pdf.save(`${person.name}/${courseName}-certificate.pdf`);

    // };

    const handleDownload = async () => {
        const element = certRef.current;
        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
            orientation: "landscape",
            unit: "px",
            format: [canvas.width, canvas.height],
        });

        pdf.addImage(imgData, "PNG", 0, 0, canvas.width, canvas.height);
        pdf.save(`${certificate.name}-${currentCertificate.name}-certificate.pdf`);
    };


    const backButton = isLoggedIn && (
        <Button variant="ghost" size="sm" leftIcon={<ArrowLeft />} onClick={() => navigate(-1)}>
            Orqaga
        </Button>
    );

    if (!certificate || !currentCertificate) {
        return (
            <div className="ui-cert-view">
                {backButton && <div className="ui-cert-view__toolbar">{backButton}</div>}
                <div className="ui-cert-view__empty">
                    <EmptyState title="Бундай сертификат мавжуд эмас" />
                </div>
            </div>
        );
    }


    // Find indexes
    // const personIndex = data.findIndex(item => item.id === id);
    // const certificateIndex = person.certificates.findIndex(item => item.id === courseId);

    return (
        <div className="ui-cert-view">
            <div className="ui-cert-view__toolbar">
                {backButton || <span />}
                <Button leftIcon={<Download />} onClick={handleDownload}>
                    Yuklab olish
                </Button>
            </div>
            {/* Tor ekranda sertifikat o'z konteynerida gorizontal scroll bo'ladi (scale ishlatilmaydi). */}
            <div className="ui-cert-view__scroll">
            <div className="ui-cert-view__canvas">
            <div className='certificate-file-container lora'>
                <div ref={certRef} className="certificate-file-box lora">
                    <div className="certificate-file lora">
                        <h1 className="certificate-file-title lora">Сертификат</h1>
                        <p className="certificate-course-title lora" style={{ paddingTop: "20px" }}>
                            НАСТОЯЩИМ УДОСТОВЕРЯЕТСЯ, что
                        </p>
                        <h1 className="certificate-file-name lora">
                            {certificate.name.split(' ').filter(Boolean).slice(0, 2).join(' ')}
                        </h1>

                        <p className="certificate-course-title lora">
                            успешно прошёл(а) обучение в рамках программы НПР по теме:
                        </p>
                        <h5 className="certificate-course-title lora" style={{ fontWeight: "800" }}>
                            {currentCertificate.name}
                        </h5>

                        <h5 className="certificate-course-title lora" style={{ fontSize: "16px" }}>
                            и выполнил(а) все требования, предусмотренные учебной программой.
                        </h5>

                        <h4 className="reg-number">
                            Регистрационный номер: {certificate.id}-{currentCertificate.id}
                        </h4>

                        <p className="certificate-date lora">
                            Дата выдачи: {currentCertificate.date}
                        </p>

                        <p className="certificate-date lora" style={{ marginTop: "0px", marginRight: "290px" }}>
                            Место проведения: г.Ташкент,
                        </p>

                        <div className="certificate-qr lora">
                            <QRCodeSVG value={url} size={100} />
                        </div>

                        <div className="certificate-logo lora">
                            <img style={{ width: "110px" }} src={Logo} alt="logo" />
                            <p className="logo-text lora">
                                International Institute of Finance and Accounting
                            </p>
                        </div>

                        <img src={Podpis} alt="signature" className="podpis lora" />
                    </div>

                    {/* Background images */}
                    <img className='back-cert lora' src={BackCert} alt="background certificate" />
                    <img className='back-cert-bottom lora' src={BackCert} alt="background certificate" />
                </div>
            </div>
            </div>
            </div>
        </div>
    );
}

export default CertificateFile;
